/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_CommentInputs */

const en_task_reminders_comment = /** @type {(inputs: Task_Reminders_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

const pt_br2_task_reminders_comment = /** @type {(inputs: Task_Reminders_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentário`)
};

/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Task_Reminders_CommentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_comment = /** @type {((inputs?: Task_Reminders_CommentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_CommentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_comment(inputs)
	return pt_br2_task_reminders_comment(inputs)
});